import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactSupport = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 20V5.778C20 4.796 19.204 4 18.222 4H5.778C4.796 4 4 4.796 4 5.778V16.445C4 17.427 4.796 18.223 5.778 18.223H16.667L20 20Z",
			stroke: "#111827",
			strokeWidth: 1.3333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.998 14.791C11.902 14.791 11.824 14.869 11.825 14.965C11.825 15.061 11.903 15.139 11.999 15.139C12.095 15.139 12.173 15.061 12.173 14.965C12.174 14.869 12.096 14.791 11.998 14.791",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.999 12.076V11.836C11.999 11.049 12.485 10.623 12.973 10.296C13.449 9.97599 13.926 9.55799 13.926 8.78699C13.926 7.72299 13.064 6.86099 12 6.86099C10.936 6.86099 10.073 7.72099 10.073 8.78499",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgContactSupport);
export default ForwardRef;
